import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from 'src/app/services/common.service';
import { DriverImportService } from 'src/app/services/driver-import.service';
import { ICellRendererParams } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'vrm-processed-file-renderer',
  template: `
    <a (click)="downloadFile($event)" class="download-link">{{ 'DRIVER_IMPORT.downloadFile' | translate }} </a>
  `,
  styles: [
    `
      .download-link {
        color: #108ed4;
        text-decoration: none;
      }
      .download-link:hover {
        text-decoration: underline;
      }
    `,
  ],
})
export class ProcessedFileRendererComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  companyName: string;

  constructor(
    private importService: DriverImportService,
    public cService: CommonService,
    private translate: TranslateService
  ) {
    this.companyName = this.cService.userProfile.company;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  downloadFile(event: Event): void {
    event.preventDefault();

    const jobId = this.params.data.jobId;
    this.importService.downloadJobFile(this.companyName, jobId, 'original').subscribe(
      (response) => {
        const file = response.body;

        if (file instanceof Blob) {
          const blobUrl = window.URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `${jobId}.csv`;
          link.click();
          window.URL.revokeObjectURL(blobUrl);
        } else {
          console.error('Invalid file format or response body:', file);
        }
      },
      (error) => {
        console.error('Error downloading file:', error);
      }
    );
  }
}
